"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddProductCrossReference = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../common");
const enums_1 = require("../enums");
class AddProductCrossReference extends common_1.UpdateAction {
}
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsNotEmpty()
], AddProductCrossReference.prototype, "productId", void 0);
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsNotEmpty()
], AddProductCrossReference.prototype, "productCode", void 0);
__decorate([
    class_validator_1.IsMongoId()
], AddProductCrossReference.prototype, "partnerOrManufacturerId", void 0);
__decorate([
    class_validator_1.IsEnum(enums_1.ProductCrossReferenceType)
], AddProductCrossReference.prototype, "referenceType", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString()
], AddProductCrossReference.prototype, "description", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString()
], AddProductCrossReference.prototype, "revision", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsArray(),
    class_validator_1.IsString({ each: true })
], AddProductCrossReference.prototype, "labels", void 0);
exports.AddProductCrossReference = AddProductCrossReference;
//# sourceMappingURL=add-product-cross-reference.action.js.map